import { z } from 'zod'

import { ZDelta } from '@/app/module/campaigns/types/schemas/common'

import ZBaseAction from './base'

const ZSubscribeAction = ZBaseAction.extend({
  subscribeToCampaign: z.object({
    allowResubscribe: z.boolean().optional(),
    campaignId: z.number(),
    campaignName: z.string(),
    delay: ZDelta.optional(),
  }),
})

export default ZSubscribeAction
